<template>
  <nav :class="theme === 'light' ? 'has-background-white' : 'has-background-black'">
    <div class="columns is-mobile is-marginless heading has-text-weight-bold">
      <div class="column left">
        <router-link
          to="/"
          class="navbar-item"
          :class="theme === 'light' ? '' : 'logo-navbar-item'"
        >
          <img
            v-if="theme === 'light'"
            class="header-logo"
            alt="beatcaps logo"
            src="img/logo_outline_font1_purple.png"
          >
          <img
            v-else
            class="header-logo"
            alt="beatcaps logo"
            src="img/logo_outline_font1_purple_white.png"
          >
        </router-link>
      </div>
      <div class="column right">
        <router-link
          to="/demo"
          class="navbar-item is-size-6"
          :class="itemClassName"
        >
          Demo
        </router-link>
        <router-link
          to="/about"
          class="navbar-item is-size-6"
          :class="itemClassName"
        >
          About
        </router-link>
        <router-link
          to="/story"
          class="navbar-item is-size-6"
          :class="itemClassName"
        >
          Our Story
        </router-link>
        <router-link
          to="/partners"
          class="navbar-item is-size-6"
          :class="itemClassName"
        >
          Partners
        </router-link>
        <a
          href="mailto:info@beatcaps.io"
          class="navbar-item is-size-6"
          :class="itemClassName"
        >Contact</a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  components: {},
  props: {
    theme: {
      default: 'light',
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {
    itemClassName () {
      return this.theme === 'light' ? 'has-text-black' : 'has-text-white'
    }
  },
  watch: {},
  methods: {}
}
</script>
<style scoped>
  .navbar-item.logo-navbar-item {
      background-color: black;
      height: auto;
      border-radius: 0;
  }
  .navbar-item img.header-logo {
    max-height: 1.8rem;
  }

</style>
